import { render, staticRenderFns } from "./Section10.vue?vue&type=template&id=8e73115c&scoped=true&"
import script from "./Section10.vue?vue&type=script&lang=js&"
export * from "./Section10.vue?vue&type=script&lang=js&"
import style0 from "./Section10.vue?vue&type=style&index=0&id=8e73115c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e73115c",
  null
  
)

export default component.exports